/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the SDRandomAccessToken
 *
 * @class SDRandomAccessToken
 */
class SDRandomAccessToken {
  /**
   * Creates an instance of SDRandomAccessToken.
   * @param {*} json
   * @memberof SDRandomAccessToken
   */
  constructor(json = null) {
    if (json) {
      // string
      this.token = json.token;
    }
  }
}

export default {
  SDRandomAccessToken,
};
